import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Carousel from '@alltrails/denali/components/Carousel';
import FacebookIcon from '@alltrails/layout/components/socialIcons/FacebookIcon';
import InstagramIcon from '@alltrails/layout/components/socialIcons/InstagramIcon';
import LinkedInIcon from '@alltrails/layout/components/socialIcons/LinkedInIcon';
import TikTokIcon from '@alltrails/layout/components/socialIcons/TikTokIcon';
import TwitterIcon from '@alltrails/layout/components/socialIcons/TwitterIcon';
import cards from './cards';
import SocialCard from './SocialCard';
import styles from './styles.module.scss';

const strong = (chunks: ReactNode) => <strong>{chunks}</strong>;

const UgcSocialFooter = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <Typography variant="heading600" component="h2">
            <FormattedMessage defaultMessage="Share your next adventure" />
          </Typography>
          <Typography variant="paragraph200" className={styles.subTitle} component="p">
            <FormattedMessage
              defaultMessage="Show us how you <strong>#GetOutThere</strong> by tagging us <strong>@AllTrails</strong> for a chance to be featured!"
              values={{ strong }}
            />
          </Typography>
        </div>
        <div className={styles.links}>
          <InstagramIcon openInNewTab />
          <TikTokIcon openInNewTab />
          <FacebookIcon openInNewTab />
          <TwitterIcon openInNewTab />
          <LinkedInIcon openInNewTab />
        </div>
      </div>
      <div className={styles.carouselContainer}>
        <Carousel
          uniqueId="ugc-social-footer"
          items={cards}
          renderItem={card => <SocialCard {...card} />}
          getItemKey={card => card.handle}
          leftArrowClassName={styles.previous}
          rightArrowClassName={styles.next}
          absoluteSizing
          slideAsSet
          showPaginationDots={false}
          showOverflow={false}
        />
      </div>
    </div>
  );
};

export default UgcSocialFooter;
